"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const assets_1 = require("~/assets");
const UI_1 = require("~/components/UI");
const consts_1 = require("~/store/account/consts");
const api_1 = require("~/store/api");
const selectors_1 = require("~/store/selectors");
const actions_1 = require("~/store/actions");
const redux_1 = require("redux");
const events_1 = require("~/utils/events");
const PdfCustomizationModal_1 = __importDefault(require("~/components/PdfCustomizationModal"));
const BOMExportButton_scss_1 = __importDefault(require("./BOMExportButton.scss"));
function BOMExportButton({ disabled, isImperialMeasurement, revisionNumber, explosionCoefficient, }) {
    var _a, _b, _c;
    const { t } = (0, react_i18next_1.useTranslation)('widgets');
    const project = (0, react_redux_1.useSelector)(selectors_1.selectCurrentProject);
    const user = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUser);
    const loadWithCustomerPrice = ((_a = user === null || user === void 0 ? void 0 : user.userType) === null || _a === void 0 ? void 0 : _a.name) === consts_1.UserRoles.distributor &&
        ((project === null || project === void 0 ? void 0 : project.customer) || ((_c = (_b = project === null || project === void 0 ? void 0 : project.user) === null || _b === void 0 ? void 0 : _b.userType) === null || _c === void 0 ? void 0 : _c.name) === consts_1.UserRoles.customer);
    const [showDropdown, setShowDropdown] = (0, react_1.useState)(false);
    const discountedPriceShown = (0, react_redux_1.useSelector)(selectors_1.selectBOMDiscountedPriceShown);
    const isExporting = (0, react_redux_1.useSelector)(selectors_1.selectBOMExporting);
    const { dispatchSetBOMExporting } = (0, redux_1.bindActionCreators)({
        dispatchSetBOMExporting: actions_1.setBOMExporting,
    }, (0, react_redux_1.useDispatch)());
    const downloadPDFClickHandler = () => __awaiter(this, void 0, void 0, function* () {
        if (!project) {
            return;
        }
        (0, events_1.showModal)(react_1.default.createElement(PdfCustomizationModal_1.default, { isImperialMeasurement: isImperialMeasurement, revisionNumber: revisionNumber, explosionCoefficient: explosionCoefficient }));
    });
    const downloadEXCELClickHandler = (exportAsCustomer) => __awaiter(this, void 0, void 0, function* () {
        if (!project) {
            return;
        }
        dispatchSetBOMExporting(true);
        try {
            const includeDiscount = discountedPriceShown || exportAsCustomer;
            const response = yield (0, api_1.downloadEXCEL)(project.id, isImperialMeasurement, exportAsCustomer, includeDiscount);
            const blob = new Blob([response.data], {
                type: response.headers['content-type'],
            });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `TSLOTS_${revisionNumber === null || revisionNumber === void 0 ? void 0 : revisionNumber.replace('-', '_')}.xlsx`;
            if ((project === null || project === void 0 ? void 0 : project.referenceNumber) && !(revisionNumber === null || revisionNumber === void 0 ? void 0 : revisionNumber.includes(project === null || project === void 0 ? void 0 : project.referenceNumber))) {
                link.download = `TSLOTS_${project === null || project === void 0 ? void 0 : project.referenceNumber}-${revisionNumber === null || revisionNumber === void 0 ? void 0 : revisionNumber.replace('-', '_')}.xlsx`;
            }
            link.click();
        }
        finally {
            dispatchSetBOMExporting(false);
        }
    });
    const dropdownItems = [
        {
            title: t('bom.pdf'),
            onClick: () => downloadPDFClickHandler(),
            icon: assets_1.svgQuoteDownload,
        },
        {
            title: loadWithCustomerPrice ? t('bom.excel-my-price') : t('bom.excel'),
            onClick: () => downloadEXCELClickHandler(false),
            icon: assets_1.svgQuoteDownloadXLSX,
        },
        {
            title: t('bom.excel-customer-price'),
            onClick: () => downloadEXCELClickHandler(true),
            icon: assets_1.svgQuoteDownloadDiscountedXLSX,
            hide: !loadWithCustomerPrice,
        },
    ];
    const dropdownElements = dropdownItems.map((item) => {
        if (item.hide) {
            return null;
        }
        return (react_1.default.createElement("div", { className: BOMExportButton_scss_1.default.item, onClick: item.onClick, key: item.title },
            react_1.default.createElement("button", { type: "button", className: BOMExportButton_scss_1.default.button },
                react_1.default.createElement("img", { src: item.icon, alt: item.title }),
                item.title)));
    });
    const isDisabled = disabled || isExporting;
    return (react_1.default.createElement(UI_1.ElementDropdown, { activeStateHandler: setShowDropdown, element: react_1.default.createElement("div", null,
            react_1.default.createElement(UI_1.Button, { icon: assets_1.svgBasicDownload, active: showDropdown, disabled: isDisabled }, t('bom.export'))), dropdown: react_1.default.createElement("div", { className: BOMExportButton_scss_1.default.container },
            react_1.default.createElement("div", { className: BOMExportButton_scss_1.default.spacer }),
            dropdownElements,
            react_1.default.createElement("div", { className: BOMExportButton_scss_1.default.spacer })), placement: "top-start", disabled: disabled }));
}
exports.default = BOMExportButton;
